import { render, staticRenderFns } from "./contactuser.vue?vue&type=template&id=40b7b046&scoped=true&"
import script from "./contactuser.vue?vue&type=script&lang=js&"
export * from "./contactuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7b046",
  null
  
)

export default component.exports